import {DDQ_SET_OPTION, DDQ_SUBMIT} from '../../Redux.constants';
import {selectDropdownOption} from './SelectDropDownOption';
import {submitAnswer} from './SubmitAnswer';

export function DDQReducer(state = {}, action) {
  switch (action.type) {
    case DDQ_SET_OPTION:
      return selectDropdownOption(state, action.payload);
    case DDQ_SUBMIT:
      return submitAnswer(state, action.payload);
    default:
      return state;
  }
}
